export type IUtmParamsCollection = Record<string, string>;

export const UTM_LOCALSTORAGE_KEY = 'uw-ppc';

export const UTM_SOURCE_VALUE_DIRECT = 'direct';
export const UTM_SOURCE_VALUE_GOOGLE = 'google';
export const UTM_SOURCE_VALUE_FACEBOOK = 'facebook';
export const UTM_SOURCE_VALUE_LINKEDIN = 'linkedin';
export const UTM_SOURCE_VALUE_TWITTER = 'twitter';
export const UTM_SOURCE_VALUE_YOUTUBE = 'youtube';
export const UTM_SOURCE_VALUE_INSTAGRAM = 'instagram';
export const UTM_SOURCE_VALUE_PINTEREST = 'pinterest';
export const UTM_SOURCE_VALUE_REDDIT = 'reddit';
export const UTM_SOURCE_VALUE_BING = 'bing';
export const UTM_SOURCE_VALUE_TIKTOK = 'tiktok';

export const UTM_PARAM_MEDIUM_ORGANIC = 'organic';
export const UTM_PARAM_MEDIUM_SOCIAL = 'social';
export const UTM_PARAM_MEDIUM_NONE = 'none';
export const UTM_PARAM_MEDIUM_REFERRAL = 'referral';

export const UTM_PARAM_CAMPAIGN = 'utm_campaign';
export const UTM_PARAM_SOURCE = 'utm_source';
export const UTM_PARAM_MEDIUM = 'utm_medium';
export const UTM_PARAM_CONTENT = 'utm_content';
export const UTM_PARAM_CAMPAIGN_ID = 'campaign_id';
export const UTM_PARAM_UTM_MATCHTYPE = 'matchtype';
export const UTM_PARAM_CURRENT_URL = 'currenturl';
export const UTM_PARAM_NETWORK = 'network';
export const UTM_PARAM_TERM = 'utm_term'; // search term
export const UTM_PARAM_ADSET_ID = 'adset_id'; // Adset ID
export const UTM_PARAM_PLACEMENT = 'placement'; // Ad placement
export const UTM_PARAM_GEO_LOC = 'GeoLoc'; // Geo location
export const UTM_PARAM_DEVICE = 'device'; // device type
export const UTM_PARAM_AD_ID = 'ad_id'; // Ad ID
export const UTM_PARAM_AD = 'utm_ad'; // utm_ad is a reserved word in JavaScript
export const UTM_PARAM_YCL_ID = 'yclid'; // Yahoo's official click ID
export const UTM_PARAM_OBC_ID = 'obcid'; // Open Broadcaster ID
export const UTM_PARAM_TTC_ID = 'ttcid'; // TikTok official click ID
export const UTM_PARAM_TBLCI = 'tblci'; // Tableau's official click ID
export const UTM_PARAM_GCL_ID = 'gclid'; // Google's official click ID
export const UTM_PARAM_GBRA_ID = 'gbraid'; // Google's app conversions driven by ad campaigns ID
export const UTM_PARAM_WBRA_ID = 'wbraid'; // Google's web-to-app measurement  ID
export const UTM_PARAM_FBCL_ID = 'fbclid'; // Facebook's official click ID
export const UTM_PARAM_FBP = 'fbp'; // Facebook's cookie, to be used with Facebook's Conversions API
export const UTM_PARAM_FBC = 'fbc'; // Facebook's cookie, to be used with Facebook's Conversions API
export const UTM_PARAM_LI_FAT_ID = 'li_fat_id'; // LinkedIn's official click ID
export const UTM_PARAM_MSCLK_ID = 'msclkid'; // Bing's official click ID
export const UTM_PARAM_REFERRER = 'referrer'; // site referrer
export const UTM_PARAM_CID = 'cid'; // GA user id
export const UTM_PARAM_UAG = 'uag'; // userAgent
export const UTM_PARAM_USER_AGENT = 'user_agent'; // userAgent alias
export const UTM_PARAM_OBCID = 'obcid'; // Open Broadcaster ID
export const UTM_PARAM_HUBSPOTUTK = 'hubspotutk'; // Hubspot token
export const UTM_USER_IP = 'user_ip'; // User IP address token

export const UTM_SOURCE_VALUE_VIMEO = 'vimeo';
export const UTM_SOURCE_VALUE_GITHUB = 'github';
export const UTM_SOURCE_VALUE_VK = 'vk';
export const UTM_SOURCE_VALUE_WATTPAD = 'wattpad';
export const UTM_SOURCE_VALUE_DEVIANTART = 'deviantart';
export const UTM_SOURCE_VALUE_TUMBLR = 'tumblr';
export const UTM_SOURCE_VALUE_WHATSAPP = 'whatsapp';
export const UTM_SOURCE_VALUE_QUORA = 'quora';
export const UTM_SOURCE_VALUE_TWITCH = 'twitch';
export const UTM_SOURCE_VALUE_YAHOO = 'yahoo';
export const UTM_SOURCE_VALUE_YANDEX = 'yandex';
export const UTM_SOURCE_VALUE_DUCKDUCKGO = 'duckduckgo';
export const UTM_SOURCE_VALUE_ASK = 'ask';
export const UTM_SOURCE_VALUE_AOL = 'aol';
export const UTM_KEYWORD_ID = 'keyword_id';
export const UTM_PARAM_ABVER = 'abver'; // website ab version
export const UTM_PARAM_AFFILIATE_CL_ID = 'aff_click_id'; // UserWay affiliate click id
export const UTM_PARAM_AFFILIATE_CL_TIMESTAMP = 'aff_timestamp'; // UserWay affiliate click timestamp

export const AFFILIATE_CLICK_ID_VALIDITY_PERIOD_MS = 60 * 24 * 3600 * 1000; // 60 days

export const UTM_PARAM_GA_SESSION_ID = 'ga4_session_id'; // GA user id

export const TRACKED_UTM_PARAMS = [
  UTM_PARAM_CAMPAIGN,
  UTM_PARAM_SOURCE,
  UTM_PARAM_MEDIUM,
  UTM_PARAM_CONTENT,
  UTM_PARAM_CAMPAIGN_ID,
  UTM_PARAM_UTM_MATCHTYPE,
  UTM_PARAM_CURRENT_URL,
  UTM_PARAM_NETWORK,
  UTM_PARAM_TERM,
  UTM_PARAM_ADSET_ID,
  UTM_PARAM_PLACEMENT,
  UTM_PARAM_GEO_LOC,
  UTM_PARAM_DEVICE,
  UTM_PARAM_AD_ID,
  UTM_PARAM_AD,
  UTM_PARAM_YCL_ID,
  UTM_PARAM_OBC_ID,
  UTM_PARAM_TTC_ID,
  UTM_PARAM_TBLCI,
  UTM_PARAM_GCL_ID,
  UTM_PARAM_GBRA_ID,
  UTM_PARAM_WBRA_ID,
  UTM_PARAM_FBCL_ID,
  UTM_PARAM_FBP,
  UTM_PARAM_FBC,
  UTM_PARAM_LI_FAT_ID,
  UTM_PARAM_MSCLK_ID,
  UTM_PARAM_REFERRER,
  UTM_PARAM_CID,
  UTM_PARAM_UAG,
  UTM_PARAM_USER_AGENT,
  UTM_PARAM_OBCID,
  UTM_PARAM_GA_SESSION_ID,
  UTM_PARAM_ABVER,
];

export const ORGANIC_SOURCES = [
  UTM_SOURCE_VALUE_GOOGLE,
  UTM_SOURCE_VALUE_BING,
  UTM_SOURCE_VALUE_YAHOO,
  UTM_SOURCE_VALUE_YANDEX,
  UTM_SOURCE_VALUE_DUCKDUCKGO,
  UTM_SOURCE_VALUE_ASK,
  UTM_SOURCE_VALUE_AOL,
];
export const UTM_SOURCE_VALUES = [
  UTM_SOURCE_VALUE_GOOGLE,
  UTM_SOURCE_VALUE_FACEBOOK,
  UTM_SOURCE_VALUE_LINKEDIN,
  UTM_SOURCE_VALUE_TWITTER,
  UTM_SOURCE_VALUE_YOUTUBE,
  UTM_SOURCE_VALUE_INSTAGRAM,
  UTM_SOURCE_VALUE_PINTEREST,
  UTM_SOURCE_VALUE_BING,
  UTM_SOURCE_VALUE_REDDIT,
  UTM_SOURCE_VALUE_TIKTOK,
  UTM_SOURCE_VALUE_VIMEO,
  UTM_SOURCE_VALUE_GITHUB,
  UTM_SOURCE_VALUE_VK,
  UTM_SOURCE_VALUE_WATTPAD,
  UTM_SOURCE_VALUE_DEVIANTART,
  UTM_SOURCE_VALUE_TUMBLR,
  UTM_SOURCE_VALUE_WHATSAPP,
  UTM_SOURCE_VALUE_QUORA,
  UTM_SOURCE_VALUE_TWITCH,
  UTM_SOURCE_VALUE_AOL,
  UTM_SOURCE_VALUE_YAHOO,
  UTM_SOURCE_VALUE_YANDEX,
  UTM_SOURCE_VALUE_ASK,
  UTM_SOURCE_VALUE_DUCKDUCKGO,
];

export const URL_QUERY_TRACKING_PARAMETERS = [
  UTM_PARAM_AFFILIATE_CL_ID,
  UTM_PARAM_AFFILIATE_CL_TIMESTAMP,
  UTM_PARAM_CAMPAIGN,
  UTM_PARAM_SOURCE,
  UTM_PARAM_MEDIUM,
  UTM_PARAM_CONTENT,
  UTM_PARAM_TERM,
  UTM_PARAM_ABVER,
];

export const SESSION_TRACKING_PARAMETERS = [
  UTM_PARAM_SOURCE,
  UTM_PARAM_MEDIUM,
  UTM_PARAM_CAMPAIGN,
  UTM_PARAM_CONTENT,
  UTM_PARAM_TERM,
  UTM_PARAM_CAMPAIGN_ID,
  UTM_PARAM_ADSET_ID,
  UTM_PARAM_AD,
  UTM_PARAM_AD_ID,
  UTM_PARAM_UTM_MATCHTYPE,
  UTM_PARAM_DEVICE,
  UTM_PARAM_PLACEMENT,
  UTM_PARAM_NETWORK,
  UTM_PARAM_GEO_LOC,
  UTM_USER_IP,
  UTM_KEYWORD_ID,
];

export const LOCAL_STORAGE_TRACKING_PARAMETERS = [
  UTM_PARAM_GCL_ID,
  UTM_PARAM_GBRA_ID,
  UTM_PARAM_WBRA_ID,
  UTM_PARAM_FBCL_ID,
  UTM_PARAM_OBC_ID,
  UTM_PARAM_TBLCI,
  UTM_PARAM_MSCLK_ID,
  UTM_PARAM_LI_FAT_ID,
  UTM_PARAM_TTC_ID,
  UTM_PARAM_YCL_ID,
  UTM_PARAM_FBP,
  UTM_PARAM_FBC,
  UTM_PARAM_CID,
  UTM_PARAM_ABVER,
];
